"use client";
import React from "react";
import * as _Builtin from "./_Builtin";
import * as _interactions from "./interactions";
import * as _utils from "./utils";
import _styles from "./AlbertaComparison.module.css";

const _interactionsData = JSON.parse(
  '{"events":{"e-387":{"id":"e-387","name":"","animationType":"preset","eventTypeId":"MOUSE_OVER","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-15","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-388"}},"mediaQueries":["main","medium"],"target":{"id":"6643b4b70da2ca862d7f4b91|0642671a-05d7-30f8-7310-9e6eb2de02f8","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"6643b4b70da2ca862d7f4b91|0642671a-05d7-30f8-7310-9e6eb2de02f8","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1699387107181},"e-388":{"id":"e-388","name":"","animationType":"preset","eventTypeId":"MOUSE_OUT","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-16","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-387"}},"mediaQueries":["main","medium"],"target":{"id":"6643b4b70da2ca862d7f4b91|0642671a-05d7-30f8-7310-9e6eb2de02f8","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"6643b4b70da2ca862d7f4b91|0642671a-05d7-30f8-7310-9e6eb2de02f8","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1699387107181},"e-440":{"id":"e-440","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SLIDE_EFFECT","instant":false,"config":{"actionListId":"slideInBottom","autoStopEventId":"e-441"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"50edfecf-3c01-3306-a094-0993257e2b7c","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"50edfecf-3c01-3306-a094-0993257e2b7c","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":100,"direction":"BOTTOM","effectIn":true},"createdOn":1716319895486},"e-442":{"id":"e-442","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SLIDE_EFFECT","instant":false,"config":{"actionListId":"slideInBottom","autoStopEventId":"e-443"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"50edfecf-3c01-3306-a094-0993257e2b7e","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"50edfecf-3c01-3306-a094-0993257e2b7e","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":200,"direction":"BOTTOM","effectIn":true},"createdOn":1716319905856},"e-444":{"id":"e-444","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SLIDE_EFFECT","instant":false,"config":{"actionListId":"slideInBottom","autoStopEventId":"e-445"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"50edfecf-3c01-3306-a094-0993257e2bd6","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"50edfecf-3c01-3306-a094-0993257e2bd6","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":100,"direction":"BOTTOM","effectIn":true},"createdOn":1716319918633},"e-446":{"id":"e-446","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SLIDE_EFFECT","instant":false,"config":{"actionListId":"slideInBottom","autoStopEventId":"e-447"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"50edfecf-3c01-3306-a094-0993257e2bdd","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"50edfecf-3c01-3306-a094-0993257e2bdd","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":200,"direction":"BOTTOM","effectIn":true},"createdOn":1716319930714},"e-448":{"id":"e-448","name":"","animationType":"preset","eventTypeId":"SCROLL_INTO_VIEW","action":{"id":"","actionTypeId":"SLIDE_EFFECT","instant":false,"config":{"actionListId":"slideInBottom","autoStopEventId":"e-449"}},"mediaQueries":["main","medium","small","tiny"],"target":{"id":"50edfecf-3c01-3306-a094-0993257e2be4","appliesTo":"ELEMENT","styleBlockIds":[]},"targets":[{"id":"50edfecf-3c01-3306-a094-0993257e2be4","appliesTo":"ELEMENT","styleBlockIds":[]}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":0,"scrollOffsetUnit":"%","delay":300,"direction":"BOTTOM","effectIn":true},"createdOn":1716319943414},"e-484":{"id":"e-484","name":"","animationType":"custom","eventTypeId":"MOUSE_OVER","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-22","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-485"}},"mediaQueries":["main","medium","small","tiny"],"target":{"selector":".tooltip-button","originalId":"f589d0dd-47fb-59a9-dbb8-58806c9b3de4","appliesTo":"CLASS"},"targets":[{"selector":".tooltip-button","originalId":"f589d0dd-47fb-59a9-dbb8-58806c9b3de4","appliesTo":"CLASS"}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1716850759690},"e-485":{"id":"e-485","name":"","animationType":"custom","eventTypeId":"MOUSE_OUT","action":{"id":"","actionTypeId":"GENERAL_START_ACTION","config":{"delay":0,"easing":"","duration":0,"actionListId":"a-21","affectedElements":{},"playInReverse":false,"autoStopEventId":"e-484"}},"mediaQueries":["main","medium","small","tiny"],"target":{"selector":".tooltip-button","originalId":"f589d0dd-47fb-59a9-dbb8-58806c9b3de4","appliesTo":"CLASS"},"targets":[{"selector":".tooltip-button","originalId":"f589d0dd-47fb-59a9-dbb8-58806c9b3de4","appliesTo":"CLASS"}],"config":{"loop":false,"playInReverse":false,"scrollOffsetValue":null,"scrollOffsetUnit":null,"delay":null,"direction":null,"effectIn":null},"createdOn":1716850759691}},"actionLists":{"a-15":{"id":"a-15","title":"button-hover-icon","actionItemGroups":[{"actionItems":[{"id":"a-15-n","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".icon-1x1-small.icon-absolute","selectorGuids":["5159a2aa-230f-0e59-0589-1af52a1bff75","5159a2aa-230f-0e59-0589-1af52a1bffef"]},"xValue":-1.5,"xUnit":"rem","yUnit":"PX","zUnit":"PX"}},{"id":"a-15-n-2","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":500,"target":{"selector":".icon-1x1-small.icon-absolute","selectorGuids":["5159a2aa-230f-0e59-0589-1af52a1bff75","5159a2aa-230f-0e59-0589-1af52a1bffef"]},"value":0,"unit":""}},{"id":"a-15-n-3","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".icon-1x1-s-medium","selectorGuids":["5159a2aa-230f-0e59-0589-1af52a1bff11"]},"xValue":0,"xUnit":"rem","yUnit":"PX","zUnit":"PX"}},{"id":"a-15-n-4","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".icon-1x1-s-medium","selectorGuids":["5159a2aa-230f-0e59-0589-1af52a1bff11"]},"value":0,"unit":""}}]},{"actionItems":[{"id":"a-15-n-5","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"outBack","duration":300,"target":{"useEventTarget":"CHILDREN","selector":".icon-1x1-small.icon-absolute","selectorGuids":["5159a2aa-230f-0e59-0589-1af52a1bff75","5159a2aa-230f-0e59-0589-1af52a1bffef"]},"xValue":0,"xUnit":"rem","yUnit":"PX","zUnit":"PX"}},{"id":"a-15-n-6","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"outBack","duration":250,"target":{"useEventTarget":"CHILDREN","selector":".icon-1x1-s-medium","selectorGuids":["5159a2aa-230f-0e59-0589-1af52a1bff11"]},"xValue":0,"xUnit":"rem","yUnit":"PX","zUnit":"PX"}},{"id":"a-15-n-7","actionTypeId":"STYLE_OPACITY","config":{"delay":100,"easing":"","duration":200,"target":{"useEventTarget":"CHILDREN","selector":".icon-1x1-small.icon-absolute","selectorGuids":["5159a2aa-230f-0e59-0589-1af52a1bff75","5159a2aa-230f-0e59-0589-1af52a1bffef"]},"value":1,"unit":""}},{"id":"a-15-n-8","actionTypeId":"STYLE_OPACITY","config":{"delay":100,"easing":"","duration":150,"target":{"useEventTarget":"CHILDREN","selector":".icon-1x1-s-medium","selectorGuids":["5159a2aa-230f-0e59-0589-1af52a1bff11"]},"value":1,"unit":""}}]}],"useFirstGroupAsInitialState":true,"createdOn":1699385442619},"a-16":{"id":"a-16","title":"button-hover-icon-out","actionItemGroups":[{"actionItems":[{"id":"a-16-n","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":300,"target":{"useEventTarget":"CHILDREN","selector":".icon-1x1-small","selectorGuids":["5159a2aa-230f-0e59-0589-1af52a1bff75"]},"xValue":-1.5,"xUnit":"rem","yUnit":"PX","zUnit":"PX"}},{"id":"a-16-n-2","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":150,"target":{"useEventTarget":"CHILDREN","selector":".icon-1x1-small","selectorGuids":["5159a2aa-230f-0e59-0589-1af52a1bff75"]},"value":0,"unit":""}},{"id":"a-16-n-3","actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"","duration":250,"target":{"useEventTarget":"CHILDREN","selector":".icon-1x1-s-medium","selectorGuids":["5159a2aa-230f-0e59-0589-1af52a1bff11"]},"xValue":-1.5,"xUnit":"rem","yUnit":"PX","zUnit":"PX"}},{"id":"a-16-n-4","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":150,"target":{"useEventTarget":"CHILDREN","selector":".icon-1x1-s-medium","selectorGuids":["5159a2aa-230f-0e59-0589-1af52a1bff11"]},"value":0,"unit":""}}]}],"useFirstGroupAsInitialState":false,"createdOn":1699385442619},"a-22":{"id":"a-22","title":"Tooltip Hover","actionItemGroups":[{"actionItems":[{"id":"a-22-n","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"useEventTarget":"CHILDREN","selector":".tooltip-wrapper","selectorGuids":["27308f57-9c22-7e7c-0de7-a722a06732c5"]},"value":"none"}},{"id":"a-22-n-2","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":500,"target":{"useEventTarget":"CHILDREN","selector":".tooltip-wrapper","selectorGuids":["27308f57-9c22-7e7c-0de7-a722a06732c5"]},"value":0,"unit":""}}]},{"actionItems":[{"id":"a-22-n-4","actionTypeId":"GENERAL_DISPLAY","config":{"delay":0,"easing":"","duration":0,"target":{"useEventTarget":"CHILDREN","selector":".tooltip-wrapper","selectorGuids":["27308f57-9c22-7e7c-0de7-a722a06732c5"]},"value":"flex"}},{"id":"a-22-n-5","actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"","duration":100,"target":{"useEventTarget":"CHILDREN","selector":".tooltip-wrapper","selectorGuids":["27308f57-9c22-7e7c-0de7-a722a06732c5"]},"value":1,"unit":""}}]}],"useFirstGroupAsInitialState":true,"createdOn":1600620259497},"a-21":{"id":"a-21","title":"Tooltip Hover Out","actionItemGroups":[{"actionItems":[{"id":"a-21-n","actionTypeId":"TRANSFORM_MOVE","config":{"delay":250,"easing":"","duration":100,"target":{"useEventTarget":"CHILDREN","selector":".tooltip-wrapper","selectorGuids":["27308f57-9c22-7e7c-0de7-a722a06732c5"]},"yValue":30,"xUnit":"PX","yUnit":"PX","zUnit":"PX"}},{"id":"a-21-n-2","actionTypeId":"STYLE_OPACITY","config":{"delay":250,"easing":"","duration":100,"target":{"useEventTarget":"CHILDREN","selector":".tooltip-wrapper","selectorGuids":["27308f57-9c22-7e7c-0de7-a722a06732c5"]},"value":0,"unit":""}}]},{"actionItems":[{"id":"a-21-n-3","actionTypeId":"GENERAL_DISPLAY","config":{"delay":100,"easing":"","duration":0,"target":{"useEventTarget":"CHILDREN","selector":".tooltip-wrapper","selectorGuids":["27308f57-9c22-7e7c-0de7-a722a06732c5"]},"value":"none"}}]}],"useFirstGroupAsInitialState":false,"createdOn":1600620457936},"slideInBottom":{"id":"slideInBottom","useFirstGroupAsInitialState":true,"actionItemGroups":[{"actionItems":[{"actionTypeId":"STYLE_OPACITY","config":{"delay":0,"duration":0,"target":{"id":"N/A","appliesTo":"TRIGGER_ELEMENT","useEventTarget":true},"value":0}}]},{"actionItems":[{"actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"duration":0,"target":{"id":"N/A","appliesTo":"TRIGGER_ELEMENT","useEventTarget":true},"xValue":0,"yValue":100,"xUnit":"PX","yUnit":"PX","zUnit":"PX"}}]},{"actionItems":[{"actionTypeId":"TRANSFORM_MOVE","config":{"delay":0,"easing":"outQuart","duration":1000,"target":{"id":"N/A","appliesTo":"TRIGGER_ELEMENT","useEventTarget":true},"xValue":0,"yValue":0,"xUnit":"PX","yUnit":"PX","zUnit":"PX"}},{"actionTypeId":"STYLE_OPACITY","config":{"delay":0,"easing":"outQuart","duration":1000,"target":{"id":"N/A","appliesTo":"TRIGGER_ELEMENT","useEventTarget":true},"value":1}}]}]}},"site":{"mediaQueries":[{"key":"main","min":992,"max":10000},{"key":"medium","min":768,"max":991},{"key":"small","min":480,"max":767},{"key":"tiny","min":0,"max":479}]}}'
);

export function AlbertaComparison({ as: _Component = _Builtin.Section }) {
  _interactions.useInteractions(_interactionsData, _styles);

  return (
    <_Component
      className={_utils.cx(_styles, "alberta_section-comparison")}
      grid={{
        type: "section",
      }}
      tag="section"
    >
      <_Builtin.Block
        className={_utils.cx(_styles, "container-large")}
        tag="div"
      >
        <_Builtin.Block
          className={_utils.cx(_styles, "padding-section-medium")}
          tag="div"
        >
          <_Builtin.Block
            className={_utils.cx(_styles, "padding-global")}
            tag="div"
          >
            <_Builtin.Block
              className={_utils.cx(
                _styles,
                "alberta_comparison-container",
                "max-width-xxlarge",
                "align-center"
              )}
              tag="div"
            >
              <_Builtin.Block
                className={_utils.cx(
                  _styles,
                  "alberta_comparison-heading",
                  "text-align-center"
                )}
                tag="div"
              >
                <_Builtin.Paragraph
                  className={_utils.cx(
                    _styles,
                    "subheading-style",
                    "text-color-brand"
                  )}
                  data-w-id="50edfecf-3c01-3306-a094-0993257e2b7c"
                >
                  {"Let's compare"}
                </_Builtin.Paragraph>
                <_Builtin.Heading
                  className={_utils.cx(_styles, "alberta_comparison-heading")}
                  data-w-id="50edfecf-3c01-3306-a094-0993257e2b7e"
                  tag="h3"
                >
                  {"Why landlords choose liv.rent over RentFaster"}
                </_Builtin.Heading>
              </_Builtin.Block>
              <_Builtin.Block
                className={_utils.cx(_styles, "alberta_comparison-grid")}
                tag="div"
              >
                <_Builtin.Block
                  className={_utils.cx(
                    _styles,
                    "alberta_comparison-table",
                    "max-width-xxlarge"
                  )}
                  tag="div"
                >
                  <_Builtin.Block
                    className={_utils.cx(_styles, "table-heading")}
                    tag="div"
                  >
                    <_Builtin.Block
                      className={_utils.cx(_styles, "tr-column", "horizontal")}
                      tag="div"
                    />
                    <_Builtin.Block
                      className={_utils.cx(
                        _styles,
                        "tr-column",
                        "align-center"
                      )}
                      tag="div"
                    >
                      <_Builtin.Block
                        className={_utils.cx(_styles, "th-heading")}
                        id={_utils.cx(
                          _styles,
                          "w-node-_50edfecf-3c01-3306-a094-0993257e2b85-257e2b76"
                        )}
                        tag="div"
                      >
                        {"RentFaster"}
                      </_Builtin.Block>
                    </_Builtin.Block>
                    <_Builtin.Block
                      className={_utils.cx(
                        _styles,
                        "tr-column",
                        "align-center"
                      )}
                      tag="div"
                    >
                      <_Builtin.Image
                        className={_utils.cx(_styles, "th-logo")}
                        id={_utils.cx(
                          _styles,
                          "w-node-_50edfecf-3c01-3306-a094-0993257e2b88-257e2b76"
                        )}
                        loading="lazy"
                        width="auto"
                        height="auto"
                        alt=""
                        src="https://uploads-ssl.webflow.com/64d3f7fe1cc4f17b36a7a5ef/66463c79044ab202c31cc784_logo.svg"
                      />
                    </_Builtin.Block>
                  </_Builtin.Block>
                  <_Builtin.Block
                    className={_utils.cx(_styles, "table-row")}
                    tag="div"
                  >
                    <_Builtin.Block
                      className={_utils.cx(_styles, "tr-column", "horizontal")}
                      tag="div"
                    >
                      <_Builtin.Block
                        className={_utils.cx(_styles, "tooltip-button")}
                        tag="div"
                      >
                        <_Builtin.Block
                          className={_utils.cx(_styles, "tooltip-wrapper")}
                          tag="div"
                        >
                          <_Builtin.Block
                            className={_utils.cx(_styles, "tooltip")}
                            tag="div"
                          >
                            <_Builtin.Block
                              className={_utils.cx(_styles, "tooltip-text")}
                              tag="div"
                            >
                              {
                                "Invite renters to apply with our application form and review all applications in one place."
                              }
                            </_Builtin.Block>
                            <_Builtin.Block
                              className={_utils.cx(_styles, "tooltip-arrow")}
                              tag="div"
                            />
                          </_Builtin.Block>
                        </_Builtin.Block>
                        <_Builtin.Block
                          className={_utils.cx(_styles, "tr-text", "small")}
                          tag="div"
                        >
                          {"Rental Listings"}
                        </_Builtin.Block>
                      </_Builtin.Block>
                    </_Builtin.Block>
                    <_Builtin.Block
                      className={_utils.cx(
                        _styles,
                        "tr-column",
                        "align-center"
                      )}
                      tag="div"
                    >
                      <_Builtin.Image
                        className={_utils.cx(_styles, "icon-1x1-s-medium")}
                        loading="lazy"
                        width="auto"
                        height="auto"
                        alt=""
                        src="https://uploads-ssl.webflow.com/64d3f7fe1cc4f17b36a7a5ef/64e64ed70b637d796e385558_tick-green.svg"
                      />
                    </_Builtin.Block>
                    <_Builtin.Block
                      className={_utils.cx(
                        _styles,
                        "tr-column",
                        "align-center"
                      )}
                      tag="div"
                    >
                      <_Builtin.Image
                        className={_utils.cx(_styles, "icon-1x1-s-medium")}
                        loading="lazy"
                        width="auto"
                        height="auto"
                        alt=""
                        src="https://uploads-ssl.webflow.com/64d3f7fe1cc4f17b36a7a5ef/64e64ed70b637d796e385558_tick-green.svg"
                      />
                    </_Builtin.Block>
                  </_Builtin.Block>
                  <_Builtin.Block
                    className={_utils.cx(
                      _styles,
                      "table-row",
                      "background-color-grey"
                    )}
                    tag="div"
                  >
                    <_Builtin.Block
                      className={_utils.cx(_styles, "tr-column", "horizontal")}
                      tag="div"
                    >
                      <_Builtin.Block
                        className={_utils.cx(_styles, "tooltip-button")}
                        tag="div"
                      >
                        <_Builtin.Block
                          className={_utils.cx(_styles, "tooltip-wrapper")}
                          tag="div"
                        >
                          <_Builtin.Block
                            className={_utils.cx(_styles, "tooltip")}
                            tag="div"
                          >
                            <_Builtin.Block
                              className={_utils.cx(_styles, "tooltip-text")}
                              tag="div"
                            >
                              {
                                "Get complete information about applicants in seconds, including Equifax® credit information, verification documents, and more."
                              }
                            </_Builtin.Block>
                            <_Builtin.Block
                              className={_utils.cx(_styles, "tooltip-arrow")}
                              tag="div"
                            />
                          </_Builtin.Block>
                        </_Builtin.Block>
                        <_Builtin.Block
                          className={_utils.cx(_styles, "tr-text", "small")}
                          tag="div"
                        >
                          {"Tenant Screening Reports"}
                        </_Builtin.Block>
                      </_Builtin.Block>
                    </_Builtin.Block>
                    <_Builtin.Block
                      className={_utils.cx(
                        _styles,
                        "tr-column",
                        "align-center"
                      )}
                      tag="div"
                    >
                      <_Builtin.Image
                        className={_utils.cx(_styles, "icon-1x1-s-medium")}
                        loading="lazy"
                        width="auto"
                        height="auto"
                        alt=""
                        src="https://uploads-ssl.webflow.com/64d3f7fe1cc4f17b36a7a5ef/64e64ed70b637d796e385558_tick-green.svg"
                      />
                    </_Builtin.Block>
                    <_Builtin.Block
                      className={_utils.cx(
                        _styles,
                        "tr-column",
                        "align-center"
                      )}
                      tag="div"
                    >
                      <_Builtin.Image
                        className={_utils.cx(_styles, "icon-1x1-s-medium")}
                        loading="lazy"
                        width="auto"
                        height="auto"
                        alt=""
                        src="https://uploads-ssl.webflow.com/64d3f7fe1cc4f17b36a7a5ef/64e64ed70b637d796e385558_tick-green.svg"
                      />
                    </_Builtin.Block>
                  </_Builtin.Block>
                  <_Builtin.Block
                    className={_utils.cx(_styles, "table-row")}
                    tag="div"
                  >
                    <_Builtin.Block
                      className={_utils.cx(_styles, "tr-column", "horizontal")}
                      tag="div"
                    >
                      <_Builtin.Block
                        className={_utils.cx(_styles, "tooltip-button")}
                        tag="div"
                      >
                        <_Builtin.Block
                          className={_utils.cx(_styles, "tooltip-wrapper")}
                          tag="div"
                        >
                          <_Builtin.Block
                            className={_utils.cx(_styles, "tooltip")}
                            tag="div"
                          >
                            <_Builtin.Block
                              className={_utils.cx(_styles, "tooltip-text")}
                              tag="div"
                            >
                              {
                                "Post one or one thousand listings - all for free."
                              }
                            </_Builtin.Block>
                            <_Builtin.Block
                              className={_utils.cx(_styles, "tooltip-arrow")}
                              tag="div"
                            />
                          </_Builtin.Block>
                        </_Builtin.Block>
                        <_Builtin.Block
                          className={_utils.cx(_styles, "tr-text", "small")}
                          tag="div"
                        >
                          {"Free Listings"}
                        </_Builtin.Block>
                      </_Builtin.Block>
                    </_Builtin.Block>
                    <_Builtin.Block
                      className={_utils.cx(
                        _styles,
                        "tr-column",
                        "align-center"
                      )}
                      tag="div"
                    >
                      <_Builtin.Image
                        className={_utils.cx(_styles, "icon-1x1-s-medium")}
                        loading="lazy"
                        width="auto"
                        height="auto"
                        alt=""
                        src="https://uploads-ssl.webflow.com/64d3f7fe1cc4f17b36a7a5ef/6646392b6a94a508d5a879b2_times-grey.svg"
                      />
                    </_Builtin.Block>
                    <_Builtin.Block
                      className={_utils.cx(
                        _styles,
                        "tr-column",
                        "align-center"
                      )}
                      tag="div"
                    >
                      <_Builtin.Image
                        className={_utils.cx(_styles, "icon-1x1-s-medium")}
                        loading="lazy"
                        width="auto"
                        height="auto"
                        alt=""
                        src="https://uploads-ssl.webflow.com/64d3f7fe1cc4f17b36a7a5ef/64e64ed70b637d796e385558_tick-green.svg"
                      />
                    </_Builtin.Block>
                  </_Builtin.Block>
                  <_Builtin.Block
                    className={_utils.cx(
                      _styles,
                      "table-row",
                      "background-color-grey"
                    )}
                    tag="div"
                  >
                    <_Builtin.Block
                      className={_utils.cx(_styles, "tr-column", "horizontal")}
                      tag="div"
                    >
                      <_Builtin.Block
                        className={_utils.cx(_styles, "tooltip-button")}
                        tag="div"
                      >
                        <_Builtin.Block
                          className={_utils.cx(_styles, "tooltip-wrapper")}
                          tag="div"
                        >
                          <_Builtin.Block
                            className={_utils.cx(_styles, "tooltip")}
                            tag="div"
                          >
                            <_Builtin.Block
                              className={_utils.cx(_styles, "tooltip-text")}
                              tag="div"
                            >
                              {
                                "Get up to 3X more inquiries by boosting your listing to the top of renters search results."
                              }
                            </_Builtin.Block>
                            <_Builtin.Block
                              className={_utils.cx(_styles, "tooltip-arrow")}
                              tag="div"
                            />
                          </_Builtin.Block>
                        </_Builtin.Block>
                        <_Builtin.Block
                          className={_utils.cx(_styles, "tr-text", "small")}
                          tag="div"
                        >
                          {"Sponsored Listings"}
                        </_Builtin.Block>
                      </_Builtin.Block>
                    </_Builtin.Block>
                    <_Builtin.Block
                      className={_utils.cx(
                        _styles,
                        "tr-column",
                        "align-center"
                      )}
                      tag="div"
                    >
                      <_Builtin.Image
                        className={_utils.cx(_styles, "icon-1x1-s-medium")}
                        loading="lazy"
                        width="auto"
                        height="auto"
                        alt=""
                        src="https://uploads-ssl.webflow.com/64d3f7fe1cc4f17b36a7a5ef/6646392b6a94a508d5a879b2_times-grey.svg"
                      />
                    </_Builtin.Block>
                    <_Builtin.Block
                      className={_utils.cx(
                        _styles,
                        "tr-column",
                        "align-center"
                      )}
                      tag="div"
                    >
                      <_Builtin.Image
                        className={_utils.cx(_styles, "icon-1x1-s-medium")}
                        loading="lazy"
                        width="auto"
                        height="auto"
                        alt=""
                        src="https://uploads-ssl.webflow.com/64d3f7fe1cc4f17b36a7a5ef/64e64ed70b637d796e385558_tick-green.svg"
                      />
                    </_Builtin.Block>
                  </_Builtin.Block>
                  <_Builtin.Block
                    className={_utils.cx(_styles, "table-row")}
                    tag="div"
                  >
                    <_Builtin.Block
                      className={_utils.cx(_styles, "tr-column", "horizontal")}
                      tag="div"
                    >
                      <_Builtin.Block
                        className={_utils.cx(_styles, "tooltip-button")}
                        tag="div"
                      >
                        <_Builtin.Block
                          className={_utils.cx(_styles, "tooltip-wrapper")}
                          tag="div"
                        >
                          <_Builtin.Block
                            className={_utils.cx(_styles, "tooltip")}
                            tag="div"
                          >
                            <_Builtin.Block
                              className={_utils.cx(_styles, "tooltip-text")}
                              tag="div"
                            >
                              {
                                "Maximize your reach with automated sharing to popular platforms like Facebook and Craigslist."
                              }
                            </_Builtin.Block>
                            <_Builtin.Block
                              className={_utils.cx(_styles, "tooltip-arrow")}
                              tag="div"
                            />
                          </_Builtin.Block>
                        </_Builtin.Block>
                        <_Builtin.Block
                          className={_utils.cx(_styles, "tr-text", "small")}
                          tag="div"
                        >
                          {"Multi-platform Advertising"}
                        </_Builtin.Block>
                      </_Builtin.Block>
                    </_Builtin.Block>
                    <_Builtin.Block
                      className={_utils.cx(
                        _styles,
                        "tr-column",
                        "align-center"
                      )}
                      tag="div"
                    >
                      <_Builtin.Image
                        className={_utils.cx(_styles, "icon-1x1-s-medium")}
                        loading="lazy"
                        width="auto"
                        height="auto"
                        alt=""
                        src="https://uploads-ssl.webflow.com/64d3f7fe1cc4f17b36a7a5ef/6646392b6a94a508d5a879b2_times-grey.svg"
                      />
                    </_Builtin.Block>
                    <_Builtin.Block
                      className={_utils.cx(
                        _styles,
                        "tr-column",
                        "align-center"
                      )}
                      tag="div"
                    >
                      <_Builtin.Image
                        className={_utils.cx(_styles, "icon-1x1-s-medium")}
                        loading="lazy"
                        width="auto"
                        height="auto"
                        alt=""
                        src="https://uploads-ssl.webflow.com/64d3f7fe1cc4f17b36a7a5ef/64e64ed70b637d796e385558_tick-green.svg"
                      />
                    </_Builtin.Block>
                  </_Builtin.Block>
                  <_Builtin.Block
                    className={_utils.cx(
                      _styles,
                      "table-row",
                      "background-color-grey"
                    )}
                    tag="div"
                  >
                    <_Builtin.Block
                      className={_utils.cx(_styles, "tr-column", "horizontal")}
                      tag="div"
                    >
                      <_Builtin.Block
                        className={_utils.cx(_styles, "tooltip-button")}
                        tag="div"
                      >
                        <_Builtin.Block
                          className={_utils.cx(_styles, "tooltip-wrapper")}
                          tag="div"
                        >
                          <_Builtin.Block
                            className={_utils.cx(_styles, "tooltip")}
                            tag="div"
                          >
                            <_Builtin.Block
                              className={_utils.cx(_styles, "tooltip-text")}
                              tag="div"
                            >
                              {
                                "Keep your team organized and assign specific listings to individual users."
                              }
                            </_Builtin.Block>
                            <_Builtin.Block
                              className={_utils.cx(_styles, "tooltip-arrow")}
                              tag="div"
                            />
                          </_Builtin.Block>
                        </_Builtin.Block>
                        <_Builtin.Block
                          className={_utils.cx(_styles, "tr-text", "small")}
                          tag="div"
                        >
                          {"Team Management"}
                        </_Builtin.Block>
                      </_Builtin.Block>
                    </_Builtin.Block>
                    <_Builtin.Block
                      className={_utils.cx(
                        _styles,
                        "tr-column",
                        "align-center"
                      )}
                      tag="div"
                    >
                      <_Builtin.Image
                        className={_utils.cx(_styles, "icon-1x1-s-medium")}
                        loading="lazy"
                        width="auto"
                        height="auto"
                        alt=""
                        src="https://uploads-ssl.webflow.com/64d3f7fe1cc4f17b36a7a5ef/6646392b6a94a508d5a879b2_times-grey.svg"
                      />
                    </_Builtin.Block>
                    <_Builtin.Block
                      className={_utils.cx(
                        _styles,
                        "tr-column",
                        "align-center"
                      )}
                      tag="div"
                    >
                      <_Builtin.Image
                        className={_utils.cx(_styles, "icon-1x1-s-medium")}
                        loading="lazy"
                        width="auto"
                        height="auto"
                        alt=""
                        src="https://uploads-ssl.webflow.com/64d3f7fe1cc4f17b36a7a5ef/64e64ed70b637d796e385558_tick-green.svg"
                      />
                    </_Builtin.Block>
                  </_Builtin.Block>
                  <_Builtin.Block
                    className={_utils.cx(_styles, "table-row")}
                    tag="div"
                  >
                    <_Builtin.Block
                      className={_utils.cx(_styles, "tr-column", "horizontal")}
                      tag="div"
                    >
                      <_Builtin.Block
                        className={_utils.cx(_styles, "tooltip-button")}
                        tag="div"
                      >
                        <_Builtin.Block
                          className={_utils.cx(_styles, "tooltip-wrapper")}
                          tag="div"
                        >
                          <_Builtin.Block
                            className={_utils.cx(_styles, "tooltip")}
                            tag="div"
                          >
                            <_Builtin.Block
                              className={_utils.cx(_styles, "tooltip-text")}
                              tag="div"
                            >
                              {
                                "A landing page that displays your company’s branding and highlights your listing portfolio."
                              }
                            </_Builtin.Block>
                            <_Builtin.Block
                              className={_utils.cx(_styles, "tooltip-arrow")}
                              tag="div"
                            />
                          </_Builtin.Block>
                        </_Builtin.Block>
                        <_Builtin.Block
                          className={_utils.cx(_styles, "tr-text", "small")}
                          tag="div"
                        >
                          {"Company Landing Page"}
                        </_Builtin.Block>
                      </_Builtin.Block>
                    </_Builtin.Block>
                    <_Builtin.Block
                      className={_utils.cx(
                        _styles,
                        "tr-column",
                        "align-center"
                      )}
                      tag="div"
                    >
                      <_Builtin.Image
                        className={_utils.cx(_styles, "icon-1x1-s-medium")}
                        loading="lazy"
                        width="auto"
                        height="auto"
                        alt=""
                        src="https://uploads-ssl.webflow.com/64d3f7fe1cc4f17b36a7a5ef/6646392b6a94a508d5a879b2_times-grey.svg"
                      />
                    </_Builtin.Block>
                    <_Builtin.Block
                      className={_utils.cx(
                        _styles,
                        "tr-column",
                        "align-center"
                      )}
                      tag="div"
                    >
                      <_Builtin.Image
                        className={_utils.cx(_styles, "icon-1x1-s-medium")}
                        loading="lazy"
                        width="auto"
                        height="auto"
                        alt=""
                        src="https://uploads-ssl.webflow.com/64d3f7fe1cc4f17b36a7a5ef/64e64ed70b637d796e385558_tick-green.svg"
                      />
                    </_Builtin.Block>
                  </_Builtin.Block>
                </_Builtin.Block>
                <_Builtin.Block
                  className={_utils.cx(
                    _styles,
                    "alberta_comparison-list",
                    "max-width-medium"
                  )}
                  tag="div"
                >
                  <_Builtin.Block
                    className={_utils.cx(
                      _styles,
                      "alberta_comparison-list-item"
                    )}
                    data-w-id="50edfecf-3c01-3306-a094-0993257e2bd6"
                    tag="div"
                  >
                    <_Builtin.Image
                      className={_utils.cx(_styles, "icon-height-medium")}
                      loading="lazy"
                      width="auto"
                      height="auto"
                      alt=""
                      src="https://uploads-ssl.webflow.com/64d3f7fe1cc4f17b36a7a5ef/6645109521c659066ba77117_green-tick-circle.svg"
                    />
                    <_Builtin.Block
                      className={_utils.cx(_styles, "alberta_comparison-copy")}
                      tag="div"
                    >
                      <_Builtin.Block
                        className={_utils.cx(_styles, "text-weight-bold")}
                        tag="div"
                      >
                        {"Post unlimited listing for free"}
                      </_Builtin.Block>
                      <_Builtin.Block
                        className={_utils.cx(
                          _styles,
                          "text-size-small",
                          "text-color-secondary"
                        )}
                        tag="div"
                      >
                        {
                          "Unlike RentFaster, we always offer free listings - forever."
                        }
                      </_Builtin.Block>
                    </_Builtin.Block>
                  </_Builtin.Block>
                  <_Builtin.Block
                    className={_utils.cx(
                      _styles,
                      "alberta_comparison-list-item"
                    )}
                    data-w-id="50edfecf-3c01-3306-a094-0993257e2bdd"
                    tag="div"
                  >
                    <_Builtin.Image
                      className={_utils.cx(_styles, "icon-height-medium")}
                      loading="lazy"
                      width="auto"
                      height="auto"
                      alt=""
                      src="https://uploads-ssl.webflow.com/64d3f7fe1cc4f17b36a7a5ef/6645109521c659066ba77117_green-tick-circle.svg"
                    />
                    <_Builtin.Block
                      className={_utils.cx(_styles, "alberta_comparison-copy")}
                      tag="div"
                    >
                      <_Builtin.Block
                        className={_utils.cx(_styles, "text-weight-bold")}
                        tag="div"
                      >
                        {"More than just a listing platform"}
                      </_Builtin.Block>
                      <_Builtin.Block
                        className={_utils.cx(
                          _styles,
                          "text-size-small",
                          "text-color-secondary"
                        )}
                        tag="div"
                      >
                        {
                          "Screen tenants, sign contracts, and receive rent payments all in one place."
                        }
                      </_Builtin.Block>
                    </_Builtin.Block>
                  </_Builtin.Block>
                  <_Builtin.Block
                    className={_utils.cx(
                      _styles,
                      "alberta_comparison-list-item",
                      "last"
                    )}
                    data-w-id="50edfecf-3c01-3306-a094-0993257e2be4"
                    tag="div"
                  >
                    <_Builtin.Image
                      className={_utils.cx(_styles, "icon-height-medium")}
                      loading="lazy"
                      width="auto"
                      height="auto"
                      alt=""
                      src="https://uploads-ssl.webflow.com/64d3f7fe1cc4f17b36a7a5ef/6645109521c659066ba77117_green-tick-circle.svg"
                    />
                    <_Builtin.Block
                      className={_utils.cx(_styles, "alberta_comparison-copy")}
                      tag="div"
                    >
                      <_Builtin.Block
                        className={_utils.cx(_styles, "text-weight-bold")}
                        tag="div"
                      >
                        {"A safer, easier way to rent"}
                      </_Builtin.Block>
                      <_Builtin.Block
                        className={_utils.cx(
                          _styles,
                          "text-size-small",
                          "text-color-secondary"
                        )}
                        tag="div"
                      >
                        {
                          "We verify tenants' ID, income & employment to help keep your property safe."
                        }
                      </_Builtin.Block>
                    </_Builtin.Block>
                  </_Builtin.Block>
                </_Builtin.Block>
              </_Builtin.Block>
            </_Builtin.Block>
          </_Builtin.Block>
        </_Builtin.Block>
      </_Builtin.Block>
    </_Component>
  );
}
